import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

//import { grey } from '@material-ui/core/colors';

import {Paper, Dialog, DialogActions, DialogContent, DialogTitle, Tabs, Tab} from '@material-ui/core'
import {Menu, MenuItem, ListItemIcon, ListItemText} from '@material-ui/core';
import {Container, Box, IconButton} from '@material-ui/core'
import {Button, FormControl, Checkbox, TextField, InputLabel, Select } from '@material-ui/core';
import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
//Typography, Paper
//import {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
//import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {MoreVert} from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import GroupIcon from '@material-ui/icons/Group';


import { isNegativeNumber, isNumber } from '../../../api/validators';
import { TabPanel } from '../../../components/TabPanel';
import { getBase64ID, getIndexByID, getObjectByID } from '../../../api/helpers';
import { EXTERNAL_PROTOCOL_TYPES } from '../../api/ServerApi';
import { EditExternalNetworkGroupDialog } from './EditExternalNetworkGroupDialog';

import * as dev from '../../../api/dev'

class EditExternalNetworkDialog_ extends React.Component{

    constructor(props){
        super(props)

        let externalNetwork = JSON.parse(JSON.stringify(this.props.externalNetwork))

        console.log('EditExternalNetworkDialog')
        console.log(props)

        this.state = {
            externalNetwork: externalNetwork,
            errors: this.errors(externalNetwork.ProtocolType),
            selectedGroupID: null,
            panelsExpanded:{
                General: true,
                Groups: true,
                PresenceCheck: true
            },
            groupEditor: {
                open: false,
                group: {},
                type: null
            },
            changed: false,
            tab: 0
        }

        this.handleTabChange = this.handleTabChange.bind(this)
        this.handleInput = this.handleInput.bind(this)
        this.handleAction = this.handleAction.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleClose = this.handleClose.bind(this)
    }

    errors(protocolType){
        switch(protocolType){
            case EXTERNAL_PROTOCOL_TYPES.EXCERA:
                return {
                    Name: false,
                    DefaultRadioID: false,
                    ServerAddress: false,
                    ServerSipPort: false,
                    GatewayAddress: false,
                    GatewayPort: false,
                    StartRtpPort: false,
                    EndRtpPort: false,
                    SoundLevel: false,

                    RadioCheckPeriod: false,
                    RadioInactivityTimeout: false,
                    FailedCheckCount: false,
                }
            case EXTERNAL_PROTOCOL_TYPES.HYTERA:
                return {
                    Name: false,
                    DefaultRadioID: false,
                    Port_Slot1_RRS: false,
                    Port_Slot2_RRS: false,
                    Port_Slot1_RCP: false,
                    Port_Slot2_RCP: false,
                    Port_Slot1_TMP: false,
                    Port_Slot2_TMP: false,
                    Port_Slot1_LP: false,
                    Port_Slot2_LP: false,
                    Port_Slot1_RTP: false,
                    Port_Slot2_RTP: false,
                    SoundLevel: false,

                    RadioCheckPeriod: false,
                    RadioInactivityTimeout: false,
                    FailedCheckCount: false,
                }
            case EXTERNAL_PROTOCOL_TYPES.KIRISUN:
                return {
                    Name: false,
                    DefaultRadioID: false,
                    ServerAddress: false,
                    ServerSipPort: false,
                    GatewayAddress: false,
                    GatewayPort: false,
                    StartRtpPort: false,
                    EndRtpPort: false,
                    SoundLevel: false,

                    RadioCheckPeriod: false,
                    RadioInactivityTimeout: false,
                    FailedCheckCount: false,
                }
            case EXTERNAL_PROTOCOL_TYPES.CALTTA:
                return {
                    Name: false,
                    DefaultRadioID: false,
                    ServerAddress: false,
                    ServerSipPort: false,
                    GatewayAddress: false,
                    GatewayPort: false,
                    StartRtpPort: false,
                    EndRtpPort: false,
                    SoundLevel: false,

                    RadioCheckPeriod: false,
                    RadioInactivityTimeout: false,
                    FailedCheckCount: false,
                }
        }
    }

    handleTabChange(event, newValue){
        this.setState({tab: newValue})
    }

    handleSave(){
        const {t} = this.props
        if(this.checkForm()){
            this.props.onAction({type: 'EXTERNAL_NETWORK_EDITOR_SAVE', externalNetwork: this.state.externalNetwork})
        }else{
            this.props.onAction({type:'ALERT_DIALOG', message: this.props.t('CheckFormForErrors')})
        }
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'EXTERNAL_NETWORK_EDITOR_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'EXTERNAL_NETWORK_EDITOR_CLOSE'})
        }
    }

    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        const externalNetwork = {...this.state.externalNetwork, [event.target.name]: val}

        const err = this.validate(event.target.name, val)
        const errors = {errors: {...this.state.errors, [event.target.name]: err}}

        this.setState({externalNetwork: externalNetwork, ...changed, ...errors})
    }


    handleAction(action){

        console.log('action')
        console.log(action)


        switch(action.type){
            case 'GROUP_EDITOR_OPEN':
                this.setState({permissionsDialogOpen: true})
                break;

            case 'EXTERNAL_NETWORK_GROUP_EDITOR_CLOSE':
            //case 'GROUP_EDITOR_CLOSE':
                this.setState({groupEditor:{open: false, group:{}, type:null}})
                break;

            case 'GROUP_EDITOR_SAVE':
                let changed = !this.state.changed ? {changed: true} : {}

                let externalNetwork = {...this.state.externalNetwork}
                let index = getIndexByID(externalNetwork.Groups, action.group.ID)
                //todo push | change groups

                //this.setState({permissionsDialogOpen: false})
                //const user = {...this.state.user, Permissions: action.permissions}
                //this.setState({user: user, ...changed})
                break;

            case 'EXTERNAL_NETWORK_GROUP_EDITOR_SAVE':{

                let changed = !this.state.changed ? {changed: true} : {}
                let externalNetwork = {...this.state.externalNetwork}
                let index = getIndexByID(action.group.ID, externalNetwork.Groups)

                if(index!==null){
                    externalNetwork.Groups[index] = action.group
                }else{
                    externalNetwork.Groups.push(action.group)
                }

                this.setState({
                    externalNetwork: externalNetwork, 
                    groupEditor:{open: false, group:{}, type:null},
                    ...changed, })
                break
            }

            default: this.props.onAction(action)
        }
    }

    validate(name, value){
        let {t} = this.props
        let error = false

        switch(name){
            case 'Name': if(!value) return t('NameIsEmpty'); 
                break

            case 'DefaultRadioID':
            case 'ServerSipPort':
            case 'GatewayPort':
            case 'StartRtpPort':
            case 'EndRtpPort':
            
            case 'RadioInactivityTimeout':

            case "Port_Slot1_RRS":
            case "Port_Slot2_RRS":
            case "Port_Slot1_RCP":
            case "Port_Slot2_RCP":
            case "Port_Slot1_TMP":
            case "Port_Slot2_TMP":
            case "Port_Slot1_LP":
            case "Port_Slot2_LP":
            case "Port_Slot1_RTP":
            case "Port_Slot2_RTP":
                if(!isNumber(value)) return this.label(name) + ': ' +  t('IsNotNumber'); 
                break

            case 'SoundLevel':
                if(!isNegativeNumber(value)) return this.label(name) + ': ' +  t('IsNotNegativeNumber'); 
                break

            case 'GatewayAddress':
            case 'ServerAddress':
                if(!value) return this.label(name) + ': ' + t('ValueIsEmpty'); 
                break

            default:
                console.log(name + ' '+ value)
        }

        //let errors = this.state.errors;
        //let error = false

        /*
        if(!this.state.user.Login){
            errors.Login = t('LoginIsEmpty')
            error = true
        }else{
            errors.Login = false
        }
        if(!this.state.user.Name){
            errors.Name = t('NameIsEmpty')
            error = true
        }else{
            errors.Name = false
        }

        if(this.state.user.LocationPeriod && !isNumber(this.state.user.LocationPeriod)){
            errors.LocationPeriod = t('IsNotNumber')
            error = true
        }else if(this.state.user.LocationPeriod && !isInteger(this.state.user.LocationPeriod)){
            errors.LocationPeriod = t('IsNotInteger')
            error = true
        }else{
            errors.LocationPeriod = false
        }
        */

        //this.setState({errors: errors})

        return error
    }

    label(name){
        let {t} = this.props
        switch(name){
            case 'ServerAddress': return t('ServerSipIp')
            case 'GatewayAddress': return t('GatewayIp')
            case 'RtpPort': return t('RtpPortRange')
            case 'SoundLevel': return t('SoundLevelDb')

            case 'Port_Slot1_RRS': return t('RrsSlot1Port')
            case 'Port_Slot2_RRS': return t('RrsSlot2Port')
            case 'Port_Slot1_RCP': return t('CallSlot1Port')
            case 'Port_Slot2_RCP': return t('CallSlot2Port')
            case 'Port_Slot1_TMP': return t('TmsSlot1Port')
            case 'Port_Slot2_TMP': return t('TmsSlot2Port')
            case 'Port_Slot1_LP': return t('LocationSlot1Port')
            case 'Port_Slot2_LP': return t('LocationSlot2Port')
            case 'Port_Slot1_RTP': return t('VoiceSlot1Port')
            case 'Port_Slot2_RTP': return t('VoiceSlot2Port')

            default: return t(name)
        }
    }

    checkForm(){
        console.log('checkform')
        console.log(this.state.externalNetwork)
        let check = true
        let errors = {...this.state.errors}
        for(var i in this.state.externalNetwork){
            let v = this.validate(i, this.state.externalNetwork[i])
            errors[i] = v         
            if(v) {
                console.error('Field: ' + i)
                console.error('Value: ' + this.state.externalNetwork[i])
                console.error('Error: ' + v)
                check = false
            }
        }
        console.log(check + ' checkform')
        this.setState({errors: errors})
        return check
    }

    togglePanel(event, expanded, panel){
        this.setState(state => {
            state.panelsExpanded[panel] = expanded
            return state
        })
    }
   
    generalTab(){
        switch(this.state.externalNetwork.ProtocolType){

            case 1: return this.exceraGeneralTab()
            case 2: return this.hyteraGeneralTab()
            case 3: return this.kirisunGeneralTab()
            case 4: return this.calttaGeneralTab()

            default: 
                dev.alert('Unknown Network Protocol '+this.state.externalNetwork.ProtocolType)
                return ''
        }
    }


    input(type, name){

        const {t} = this.props

        const margin = {margin:'16px 0 8px 0'}

        switch(type){

            case "text_input":
                return (
                    <Box textAlign="center">
                        <TextField name={name}  margin="normal"
                            style={{width: '100%'}}
                            label={this.state.errors[name]?this.state.errors[name]:this.label(name)}
                            autoComplete="new-password"
                            error={this.state.errors[name]!==false}
                            value={this.state.externalNetwork[name]}
                            onChange={this.handleInput}
                        />
                    </Box>
                )

            case "select_codec":
                return(
                    <Box textAlign="left">
                        <FormControl style={{...margin, width: '100%'}}>
                            <InputLabel htmlFor={name}>{this.label(name)}</InputLabel>
                            <Select
                                value={this.state.externalNetwork[name]}
                                onChange={this.handleInput}
                                inputProps={{name: name, id: name}}
                                >
                                <MenuItem key="0" value={0}>U-LAW</MenuItem>
                                <MenuItem key="1" value={8}>A-LAW</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                )

            case 'port_range':
                return(
                    <Box textAlign="left">
                        <TextField name={'Start'+name}  margin="normal"
                            style={{width: '45%', marginRight:20}}
                            label={this.state.errors['Start'+name]?this.state.errors['Start'+name]:t('RtpStartPortRange')}
                            autoComplete="new-password"
                            error={this.state.errors['Start'+name]!==false}
                            value={this.state.externalNetwork['Start'+name]}
                            onChange={this.handleInput}
                        />
                        <TextField name={'End'+name}  margin="normal"
                            style={{width: '45%', marginLeft:20}}
                            label={this.state.errors['End'+name]?this.state.errors['End'+name]:t('RtpEndPortRange')}
                            autoComplete="new-password"
                            error={this.state.errors['End'+name]!==false}
                            value={this.state.externalNetwork['End'+name]}
                            onChange={this.handleInput}
                        />
                    </Box>
                )

            case 'checkbox':
                //let disabled = name==='IsXpt' ? {disabled: true} : {}
                return(
                    <Box textAlign="left" style={{...margin, width: '100%'}}>
                    <FormControl>
                        <label>
                            {this.label(name)}
                            <Checkbox color="primary" 
                                checked={this.state.externalNetwork[name]}
                                onChange={this.handleInput}
                                name={name}
                                />
                        </label>
                    </FormControl>
                    </Box>
                )
        }

    }

    exceraGeneralTab(){
        return <>
            {this.input('text_input', 'Name')}
            {this.input('text_input', 'DefaultRadioID')}
            {this.input('text_input', 'ServerAddress')}
            {this.input('text_input', 'ServerSipPort')}
            {this.input('text_input', 'GatewayAddress')}
            {this.input('text_input', 'GatewayPort')}
            {this.input('select_codec', 'Codec')}
            {this.input('port_range', 'RtpPort')}
            {this.input('text_input', 'SoundLevel')}
        </>
    }

    hyteraGeneralTab(){
        return <>
            {this.input('text_input', 'Name', 'Name')}
            {this.input('checkbox', 'IsXpt')}
            {this.input('text_input', 'DefaultRadioID')}
            {this.input('text_input', 'Port_Slot1_RRS')}
            {this.input('text_input', 'Port_Slot2_RRS')}
            {this.input('text_input', 'Port_Slot1_RCP')}
            {this.input('text_input', 'Port_Slot2_RCP')}
            {this.input('text_input', 'Port_Slot1_TMP')}
            {this.input('text_input', 'Port_Slot2_TMP')}
            {this.input('text_input', 'Port_Slot1_LP')}
            {this.input('text_input', 'Port_Slot2_LP')}
            {this.input('text_input', 'Port_Slot1_RTP')}
            {this.input('text_input', 'Port_Slot2_RTP')}
            {this.input('text_input', 'SoundLevel')}
            {this.input('checkbox', 'QuickGps')}
        </>
    }

    calttaGeneralTab(){
        return <>
            {this.input('text_input', 'Name', 'Name')}
            {this.input('text_input', 'DefaultRadioID', 'DefaultRadioID')}
            {this.input('text_input', 'ServerAddress', 'ServerSipIp')}
            {this.input('text_input', 'ServerSipPort', 'ServerSipPort')}
            {this.input('text_input', 'GatewayAddress', 'GatewayIp')}
            {this.input('text_input', 'GatewayPort', 'GatewayPort')}
            {this.input('select_codec', 'Codec', 'Codec')}
            {this.input('port_range', 'RtpPort', 'RtpPortRange')}
            {this.input('text_input', 'SoundLevel', 'SoundLevelDb')}
        </>
    }

    kirisunGeneralTab(){
        return <>
            {this.input('text_input', 'Name', 'Name')}
            {this.input('text_input', 'DefaultRadioID', 'DefaultRadioID')}
            {this.input('text_input', 'ServerAddress', 'ServerSipIp')}
            {this.input('text_input', 'ServerSipPort', 'ServerSipPort')}
            {this.input('text_input', 'GatewayAddress', 'GatewayIp')}
            {this.input('text_input', 'GatewayPort', 'GatewayPort')}
            {this.input('select_codec', 'Codec', 'Codec')}
            {this.input('port_range', 'RtpPort', 'RtpPortRange')}
            {this.input('text_input', 'SoundLevel', 'SoundLevelDb')}
        </>
    }

    presenceCheckTab(){
        const {t} = this.props
        const margin = {margin:'16px 0 8px 0'}

        return(
            <>
            
                <Box textAlign="left" style={{...margin, width: '100%'}}>
                    <FormControl>
                        <label>
                            <Checkbox color="primary" 
                                checked={Boolean(this.state.externalNetwork.EnableRadioCheck)}
                                onChange={this.handleInput}
                                name="EnableRadioCheck"
                                />
                                {t('EnablePresenceCheck')}
                        </label>
                    </FormControl>
                </Box>


                <Box textAlign="center">
                    <TextField type="text" name="RadioInactivityTimeout" margin="normal"
                        style={{width: '100%'}}
                        disabled={!this.state.externalNetwork.EnableRadioCheck}
                        label={this.state.errors.RadioInactivityTimeout?this.state.errors.RadioInactivityTimeout:t('RadioInactivityTimeout')}
                        autoComplete="new-password"
                        error={this.state.errors.RadioInactivityTimeout!==false}
                        value={this.state.externalNetwork.RadioInactivityTimeout}
                        onChange={this.handleInput.bind(this)}
                    />
                </Box>

                <Box textAlign="center">
                    <TextField type="text" name="RadioCheckPeriod" margin="normal"
                        style={{width: '100%'}}
                        disabled={!this.state.externalNetwork.EnableRadioCheck}
                        label={this.state.errors.RadioCheckPeriod?this.state.errors.RadioCheckPeriod:t('RadioCheckInterval')}
                        autoComplete="new-password"
                        error={this.state.errors.RadioCheckPeriod!==false}
                        value={this.state.externalNetwork.RadioCheckPeriod}
                        onChange={this.handleInput.bind(this)}
                    />
                </Box>
            
                <Box textAlign="center">
                    <TextField type="text" name="FailedCheckCount" margin="normal"
                        style={{width: '100%'}}
                        disabled={!this.state.externalNetwork.EnableRadioCheck}
                        label={this.state.errors.FailedCheckCount?this.state.errors.FailedCheckCount:t('PresenceCheckAttemts')}
                        autoComplete="new-password"
                        error={this.state.errors.FailedCheckCount!==false}
                        value={this.state.externalNetwork.FailedCheckCount}
                        onChange={this.handleInput.bind(this)}
                    />
                </Box>
                
            </>
        )
    }

    groupsTab(){

        const {t} = this.props

        const margin = {margin:'16px 0 8px 0'}
        
        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            }
        };

        return (

        <Box textAlign="center" style={{...margin, width: '100%'}}>

            {this.state.groupEditor.open?(
                <EditExternalNetworkGroupDialog {...this.state.groupEditor}
                    onAction={this.handleAction} />
            ) : null}
            
            <Paper style={{maxHeight: 250, overflow: 'auto'}}>
            <Table size="small">

                <TableHead>
                    <TableRow>
                        <TableCell style={{...styles.head}}></TableCell>
                        <TableCell style={styles.head}>{t('Name')}</TableCell>
                        <TableCell style={styles.head}>{t('GroupID')}</TableCell>
                        <TableCell style={styles.head}>{t('Slot')}</TableCell>
                        <TableCell style={{...styles.head, width:40}}>
                                <IconButton size="small" color="primary" aria-label="more" component="span"
                                    style={styles.addIcon}
                                    onClick={(event)=>{this.handleMenuAddItemClick(event)}}>
                                    <AddCircleOutlineIcon />
                                </IconButton>
                            </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        this.state.externalNetwork.Groups.map((group, index)=>{

                        console.log('group')
                        console.log(group)
                        return (
                        <>
                            <TableRow key={group.ID} 
                                style={this.getGroupStyle(group.ID)}
                                onClick={()=>{this.handleGroupSelect(group.ID)}}
                                onDoubleClick={()=>{this.handleMenuItemClick('EXTERNAL_NETWORK_GROUP_EDITOR_OPEN', group.ID)}}
                            >
                                <TableCell style={{width:50}}><GroupIcon color="primary" /></TableCell>
                                <TableCell style={{width2:50}}>
                                    {group.Name}
                                </TableCell>
                                <TableCell style={{width2:50}}>
                                    {group.GroupID}
                                </TableCell>
                                <TableCell style={{width2:50}}>
                                    {this.slotName(group.Slot)}
                                </TableCell>
                                <TableCell style={{width:40}}>
                                    <IconButton size="small" color="inherit" aria-label="add" component="span"
                                        onClick={event=>this.handleMenuClick(event, group.ID)}>
                                        <MoreVert />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        </>
                        
                        )

                    })
                }
                </TableBody>

                <Menu anchorEl={this.state.menuAnchor} keepMounted
                    open={Boolean(this.state.menuAnchor)} onClose={this.handleMenuClose.bind(this)}>
                    <MenuItem onClick={()=>{this.handleMenuItemClick('EXTERNAL_NETWORK_GROUP_EDITOR_OPEN', this.state.menuItemID)}}>
                        <ListItemIcon><EditIcon/></ListItemIcon>
                        <ListItemText primary={t('EditGroup')} />
                    </MenuItem>
                    <MenuItem onClick={()=>{this.handleMenuItemClick('EXTERNAL_NETWORK_GROUP_EDITOR_DELETE', this.state.menuItemID)}}>
                        <ListItemIcon><DeleteForeverIcon/></ListItemIcon>
                        <ListItemText primary={t('DeleteGroup')} />
                    </MenuItem>
                </Menu>

            </Table>
            </Paper>

        </Box>

        )


    }

    slotName(slot){
        switch(slot){
            case 0: return "PseudoTrunc" 
            default: return slot

        }

    }

    handleGroupSelect(groupID){
        this.setState({selectedGroupID: groupID})
    }

    getGroupStyle(groupID){
        let selected = groupID === this.state.selectedGroupID
        let style = {
            background: selected? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }


    handleMenuAddItemClick(event){

            const group = {
                ID: getBase64ID(),
                Name: '',
                GroupID: 0,
                Slot: 1
            }

            this.setState({
                groupEditor:{
                    open: true,
                    group: group,
                    type: null
                }
            })

    }

    handleMenuClick(event, itemID){
        console.log('handleMenuClick')
        console.log(itemID)
        this.setState({menuAnchor: event.currentTarget, menuItemID: itemID});
        event.stopPropagation();
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null});
        return null;
    }

    handleMenuItemClick(action, groupID){
        console.log(action+ ' '+groupID)
        switch(action){
            case 'EXTERNAL_NETWORK_GROUP_EDITOR_OPEN':{
                let net = {...this.state.externalNetwork}
                let group = getObjectByID(groupID, net.Groups)
                console.log('group')
                console.log(group)
                this.setState({
                    groupEditor: {
                        open: true,
                        group: {...group},
                        type: net.ProtocolType
                    },
                    menuAnchor: null
                })
                break
            }


            case 'EXTERNAL_NETWORK_GROUP_EDITOR_DELETE':{

                let externalNetwork = {...this.state.externalNetwork}

                //debugger

                let index = getIndexByID(groupID, externalNetwork.Groups)

                let groups = [...externalNetwork.Groups]
                groups.splice(index, 1)

                externalNetwork.Groups = groups

                //debugger

                this.setState({
                    externalNetwork: externalNetwork, 
                    menuAnchor: null
                })
                break
            }

 /*
            case 'FIELD_TEMPLATE_ENUM_EDITOR_OPEN':{
                let template = {...this.state.template}
                let field = template.Fields[index]
                console.log(field)
                this.setState({
                    enumEditor: {
                        open: true,
                        fieldIndex: index,
                        field: field
                    },
                    menuAnchor: null
                })
                break
            }
*/
            case 'EXTERNAL_NETWORK_GROUP_EDITOR_CLOSE':{
                this.setState({
                    groupEditor: {
                        open: false,
                        group: {},
                        type: null
                    }
                })
                break
            }

            default:
                dev.alert('EditExternalNetworkDialog handleMenuItemClick '+ action)
            
        }
    }

    //EnableRadioCheck

    render(){
        const {t} = this.props

        console.log('this.state.externalNetwork')
        console.log(this.state.externalNetwork)

        let title = ''
        switch(this.state.externalNetwork.ProtocolType){
            case EXTERNAL_PROTOCOL_TYPES.EXCERA: title = t('DmrNetworkExcera'); break
            case EXTERNAL_PROTOCOL_TYPES.HYTERA: title = t('DmrNetworkHytera'); break
            case EXTERNAL_PROTOCOL_TYPES.KIRISUN: title = t('DmrNetworkKirisun'); break
            case EXTERNAL_PROTOCOL_TYPES.CALTTA: title = t('DmrNetworkCaltta'); break
        }
        

        //const margin = {margin:'16px 0 8px 0'}
        const tabStyle = {minHeight: 300}

        //let groupDialog = ''
        /*
        let groupDialog = this.state.groupDialog.open ? (
            <EditUserPermissionsDialog
                open={this.state.permissionsDialogOpen}
                permissions={this.state.user.Permissions}
                onAction={this.handleAction.bind(this)}
                />
        ) : ''
*/

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:550}}>

  
            <Tabs  value={this.state.tab} 
                variant="scrollable"
                scrollButtons="auto"
                onChange={this.handleTabChange} aria-label="simple tabs example"
                indicatorColor="primary">
                <Tab wrapped style={{minWidth:80}} label={t("General")} id="tab-0" aria-controls="tabpanel-0" />
                <Tab wrapped style={{minWidth:80}} label={t("Groups")} id="tab-1" aria-controls="tabpanel-1" />
                <Tab wrapped style={{minWidth:80}} label={t("PresenceCheck")} id="tab-2" aria-controls="tabpanel-2" />
            </Tabs>
  

            <TabPanel value={this.state.tab} index={0} style={tabStyle}>
                {this.generalTab()}
            </TabPanel>

            <TabPanel value={this.state.tab} index={1} style={tabStyle}>
                {this.groupsTab()}
            </TabPanel>

            <TabPanel value={this.state.tab} index={2} style={tabStyle}>
                {this.presenceCheckTab()}
            </TabPanel>

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const EditExternalNetworkDialog = withTranslation()(EditExternalNetworkDialog_);